export type ModalWidths = 'small' | 'medium' | 'large' | 'xlarge' | 'max' | 'fullscreen';

export const getADSModalWidth = (
	modalSize: ModalWidths,
): 'small' | 'medium' | 'large' | 'x-large' | '100%' | 'fullscreen' => {
	switch (modalSize) {
		case 'xlarge':
			return 'x-large';
		case 'max':
			return '100%';
		default:
			return modalSize;
	}
};
